import React from 'react';
import { H1, H3, typographyPropTypes } from '~typography';
import { RenderButton } from '~button';
import CtaButton from './CtaButton';
import CtaListContainer from './CtaListContainer';
import commercePropTypes from '../../prop-types/commercePropTypes';
import CtaButtonContainer from './CtaButtonContainer';

var Description = function Description(_ref) {
  var title = _ref.title,
      titleColor = _ref.titleColor,
      subtitle = _ref.subtitle,
      subtitleColor = _ref.subtitleColor,
      ctaList = _ref.ctaList;
  return /*#__PURE__*/React.createElement(React.Fragment, null, title && /*#__PURE__*/React.createElement(H1, {
    color: titleColor
  }, title), subtitle && /*#__PURE__*/React.createElement(H3, {
    color: subtitleColor
  }, subtitle), ctaList && /*#__PURE__*/React.createElement(CtaListContainer, null, ctaList.map(function (ctaItem, index) {
    var path = ctaItem.path,
        onClick = ctaItem.onClick,
        button = ctaItem.button,
        label = ctaItem.label;
    return /*#__PURE__*/React.createElement(CtaButtonContainer, {
      key: index
    }, /*#__PURE__*/React.createElement(CtaButton, null, /*#__PURE__*/React.createElement(RenderButton, {
      path: path,
      onClick: onClick,
      btnType: button === null || button === void 0 ? void 0 : button.btnType,
      skin: button === null || button === void 0 ? void 0 : button.skin,
      size: button === null || button === void 0 ? void 0 : button.size
    }, label)));
  })));
};

Description.defaultProps = {
  title: undefined,
  titleColor: 'dark',
  subtitle: undefined,
  subtitleColor: 'muted',
  ctaList: undefined
};
export default Description;